import { Backdrop, Card, CardContent, CircularProgress, Switch, makeStyles, FormControlLabel } from "@material-ui/core";
import isEmpty from 'lodash.isempty';
import { useConfirm } from 'material-ui-confirm';
import { CreateBraintreeCardForm } from "pages/CustomerBooking/Payment/CreateBraintreeCardForm";
import { CreateBraintreeDropin } from "pages/CustomerBooking/Payment/CreateBraintreeDropin";
import { CreateCardForm } from 'pages/CustomerBooking/Payment/CreateCardForm';
import { ExistingPaymentOptions } from 'pages/CustomerBooking/Payment/ExistingPaymentOptions';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { STEP_PAYMENT, STEP_SCHEDULE } from 'pages/CustomerBookingCreate/constants';
import { useCreateBooking } from 'pages/CustomerBookingCreate/createHook';
import { bookingState } from 'pages/CustomerBookingCreate/state';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import ReactJson from 'react-json-view';
import { useRecoilState } from 'recoil';
import { useUserState } from 'services/authentication.service';
import { confirmBooking } from 'services/booking.service';
import locationsService from 'services/locations.service';
import { deleteCCPaymentMethod, setDefaultPaymentMethod, setPaymentForRequest } from 'services/payments.service';
import { toasterror } from "util/toasterror";
import { useTrackEvent } from 'util/trackEvent';
import voca from 'voca'
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const PaymentScreen = ({ }) => {
  const classes = useStyles()
  const [reloadHash, setReloadHash] = useState('');
  const confirm = useConfirm()

  const [loading, setLoading] = useState(false);
  const { createBooking } = useCreateBooking()

  const [booking, setBooking] = useRecoilState(bookingState);
  const { getUser } = useUserState()
  const trackEvent = useTrackEvent()

  const confirmDelete = useCallback(
    async (cardInfo) => {
      const cardMeta = cardInfo?.last4 ? [cardInfo?.label, voca.capitalize(cardInfo?.card_type), voca.capitalize(cardInfo?.type), `ending with ${cardInfo?.last4}`].filter(x => !isEmpty(x)).join(' ') : [cardInfo?.label, cardInfo?.email].filter(x => !isEmpty(x)).join(' ')
      try {
        await confirm({
          title: 'Delete Payment Method',
          description: `Are you sure you want to delete payment method ${cardMeta}? This action cannot be undone.`,
        })
        trackEvent('Create Booking Payment - Delete Card Dialog Ok', { card: cardMeta })
        await deleteCCPaymentMethod(cardInfo?.token)
        // await setDefaultPaymentMethod(null)
        setReloadHash(new Date())
      } catch (e) {
        trackEvent('Create Booking Payment - Delete Card Dialog Cancel', { card: cardMeta })
      }
    },
    [confirm],
  );

  const onProcessPayment = useCallback(
    async (target) => {
      try {
        setLoading(true)
        const user = await getUser()
        if (!booking?.location?.id) {
          const locationRes = await locationsService.addClientLocation(user?.client?.id, booking?.location)
          await setBooking({
            ...booking,
            location: locationRes,
            payment: target,
          })
        } else {
          await setBooking({
            ...booking,
            payment: target,
          })
        }
        await createBooking()
        setLoading(false)
      } catch (error) {
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details, { error })
        setLoading(false)
      }

    },
    [booking],
  );

  const [abBraintree, setAbBraintree] = useState(false);
  const [createMode, setCreateMode] = useState(false);
  return (
    <>
      <PageHeader
        backStep={STEP_SCHEDULE}
        currentStep={STEP_PAYMENT}
        title={"Book your appointment"}
        subheader={"No charges until you finished your appointment."}
        isCartEnabled={false}
      >
        <div>
          <Card>
            <CardContent>
              {/* <FormControlLabel
                control={<Switch size="small" checked={abBraintree} onChange={() => setAbBraintree(!abBraintree)} />}
                label="Braintree"
              /> */}
              {abBraintree ? (
                <CreateBraintreeCardForm
                  onSuccess={() => setReloadHash(new Date())}
                  onEnterCreateMode={() => setCreateMode(true)}
                  onExitCreateMode={() => setCreateMode(false)}
                />
              ) : (
                <CreateCardForm
                  onSuccess={() => setReloadHash(new Date())}
                  onEnterCreateMode={() => setCreateMode(true)}
                  onExitCreateMode={() => setCreateMode(false)}
                />
              )}

            </CardContent>
          </Card>
          {!createMode && (
            <ExistingPaymentOptions
              reloadHash={reloadHash}
              onDeleteOption={(target) => confirmDelete(target)}
              onSelectOption={(target) => onProcessPayment(target)}
            />
          )}
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      </PageHeader>
    </>
  )
}

export { PaymentScreen }